import { ApiException } from '@api/api';
import { createSelector, Selector } from '@ngrx/store';
import { BaseState, getStateError, LoadingState, RequestState } from './base.state';

export const selectRequestState = createSelector(
  (state: BaseState) => state.requestState,
  (requestState: RequestState) => requestState
);

export const selectIsLoading = (parentStateSelector: Selector<object, BaseState>) =>
  createSelector<object, BaseState, boolean>(
    parentStateSelector,
    (state: BaseState) => state.requestState === LoadingState.LOADING
  );

export const selectIsLoaded = (parentStateSelector: Selector<object, BaseState>) =>
  createSelector<object, BaseState, boolean>(
    parentStateSelector,
    (state: BaseState) => state.requestState === LoadingState.LOADED
  );

export const selectError = (parentStateSelector: Selector<object, BaseState>) =>
  createSelector<object, BaseState, Error | string | ApiException | null>(
    parentStateSelector,
    (state: BaseState) => getStateError(state.requestState)
  );
